// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
import { useCallback, useState } from 'react';
import api from '../../utils/api';

/**
 * Comptes de l'équipe Vigeos, pour le champ « compte de provisionnement » d'un
 * établissement. Rend `[vigeosAccounts, loadAccounts]` : la liste est lue à la
 * première ouverture d'un formulaire qui en a besoin, pas au chargement de la
 * page, et une seule fois.
 */
export default function useVigeosAccounts() {
  const [vigeosAccounts, setVigeosAccounts] = useState([]);

  const loadAccounts = useCallback(async () => {
    if (vigeosAccounts.length) return;
    try {
      const res = await api.get('/auth/users');
      setVigeosAccounts(Array.isArray(res.data) ? res.data : []);
    } catch {
      // Sans cette liste, le champ disparaît du formulaire et le serveur retient
      // le compte appelant, qui est le bon défaut : pas d'erreur affichée.
      setVigeosAccounts([]);
    }
  }, [vigeosAccounts.length]);

  return [vigeosAccounts, loadAccounts];
}
